const axios = require("axios");
import i18n from "@/i18n";

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
// axios.interceptors.request.use(function(config) {
//   config.headers.Authorization = localStorage.getItem("Token") || "";
//   return config;
// });
const state = {
  status: "",
  token: localStorage.getItem("Token") || "",
  userid: null,
  email: "",
  fullname: "",
  lang: localStorage.getItem("detectedlanguage") || "en",
  user: {},
  tagprofiles: [],
};
const getters = {
  TagProfiles: (state) => state.tagprofiles,
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
  fullName: (state) => state.fullname,
  email: (state) => state.email,
  userId: (state) => state.userid,
  getUser: (state) => {
    let _Return = state.user;
    if (!_Return.Lang) {
      _Return.Lang =
        localStorage.getItem("setlanguage") ||
        localStorage.getItem("detectedlanguage");
    }
    return _Return;
  },
  getLang: (state) => state.lang,
};
const mutations = {
  setFullName(state, newName) {
    state.fullname = newName;
  },
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, payload) {
    state.status = "success";
    state.token = payload.token;
    state.user = payload.user;
    state.userid = state.user.id;
    state.lang =
      state.user.Lang || localStorage.getItem("detectedlanguage") || "en";

    state.email = state.user.Email;
    state.fullname = state.user.FullName;
    localStorage.setItem("setlanguage", state.lang);
    localStorage.setItem("Token", state.token);
  },
  auth_error(state) {
    state.status = "error";
  },
  logout(state) {
    state.status = "";
    state.token = "";
    state.user = {};
    state.lang = localStorage.getItem("detectedlanguage") || "en";
    state.userid = null;
    state.email = "";
    state.fullname = "";
    localStorage.removeItem("Token");
    state.tagprofiles = [];
  },

  SETLANGUAGE(state, payload) {
    state.lang = payload;
    localStorage.setItem("setlanguage", state.lang);
  },
  SETTAGPROFILES(state, payload) {
    state.tagprofiles = payload;
  },
};
const actions = {
  GET_TAGPROFILES({ commit }) {
    axios
      .post("/tagprofile", {
        TransferType: "getprofiles",
      })
      .then((resp) => {
        let _data = resp.data.map((tagprofile) => {
          return {
            ...tagprofile,
            Geo: {
              SearchTags: tagprofile.GeoTags,
              SearchTimeout: null,
              IsLoading: false,
              Search: "",
            },
            Tag: {
              SearchTags: tagprofile.Tags,
              SearchTimeout: null,
              IsLoading: false,
              Search: "",
            },
          };
        });
        _data = [
          {
            id: 0,
            Name: i18n.t("Main Page"),
            GeoTags: [],
            Tags: [],
            Geo: {
              SearchTags: [],
              SearchTimeout: null,
              IsLoading: false,
              Search: "",
            },
            Tag: {
              SearchTags: [],
              SearchTimeout: null,
              IsLoading: false,
              Search: "",
            },
          },
          ..._data,
        ];
        commit("SETTAGPROFILES", _data);
      });
  },
  updateLanguage({ commit }, payload) {
    commit("SETLANGUAGE", payload);
  },
  login({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios
        .post("/login", userData)
        .then((resp) => {
          if (resp && resp.data && resp.data.Transfer) {
            switch (resp.data.Transfer) {
              case "200":
                const user = resp.data.UserSignIn;
                const token = user.Token;
                commit("auth_success", { token, user });
                dispatch("GET_TAGPROFILES");

                resolve("Valid login, continuing");
                // console.log(resp.data);
                break;
              case "401.u":
                commit("auth_error");
                reject("AUTH_ERROR");
                break;
              case "401.p":
                commit("auth_error");
                reject("AUTH_ERROR");
                break;
              default:
                reject(`Unknown errorcode ${resp.data.Transfer}`);
            }
          }
        })
        .catch((err) => {
          commit("auth_error");
          localStorage.removeItem("Token");
          reject(err);
        });
    });
  },
  register({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios
        .post("/user", user)
        .then((resp) => {
          // console.log(resp);
          const user = resp.data.UserSignIn;
          const token = user.Token;
          commit("auth_success", { token, user });
          dispatch("UPDATE_ALL_LANGUAGE_RELATED");

          resolve(resp);
        })
        .catch((err) => {
          // console.log(err);
          commit("auth_error");
          localStorage.removeItem("Token");
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit("logout");
      localStorage.removeItem("Token");
      resolve();
    });
  },
  loginWithToken({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      axios
        .post("/logintoken", {})
        .then((resp) => {
          const user = resp.data.UserSignIn;
          const token = user.Token;
          commit("auth_success", { token, user });
          dispatch("UPDATE_ALL_LANGUAGE_RELATED");
          dispatch("GET_TAGPROFILES");

          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          localStorage.removeItem("Token");
          reject(err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
